import { UnitNumberPattern } from '../models/block.model';

export const UNIT_NUMBER_PATTERN_LABELS: Record<UnitNumberPattern, string> = {
	continuous: 'Continuous',
	odd: 'Odd numbers only',
	even: 'Even numbers only',
};

export const formatUnitNumberPreview = (
	unitFrom: number,
	unitTo: number,
	pattern: UnitNumberPattern,
	maximumVisibleUnits = 8
): string => {
	if (!Number.isInteger(unitFrom) || !Number.isInteger(unitTo) || unitFrom <= 0 || unitFrom > unitTo) {
		return '';
	}

	let nextUnit = unitFrom;
	if (pattern === 'odd' && nextUnit % 2 === 0) nextUnit += 1;
	if (pattern === 'even' && nextUnit % 2 !== 0) nextUnit += 1;

	const increment = pattern === 'continuous' ? 1 : 2;
	const units: number[] = [];
	while (nextUnit <= unitTo && units.length < maximumVisibleUnits) {
		units.push(nextUnit);
		nextUnit += increment;
	}

	if (!units.length) return '';

	return `${units.join(', ')}${nextUnit <= unitTo ? ', …' : ''}`;
};
